import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  item: {},
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_ORG_REQUEST],
  falseTypes: [actions.GET_ORG_SUCCESS, actions.GET_ORG_FAILURE],
})

const item = (state = initialState.item, { type, payload }) => {
  if (type === actions.GET_ORG_SUCCESS) {
    return payload
  }
  return state
}

export default combineReducers({
  isFetching,
  item,
})



// WEBPACK FOOTER //
// ./src/reducers/organization.js